<template>
  <BaseLayout
    class="layout--minimal"
    theme-header="small"
    theme-footer="small"
  >
    <slot />
  </BaseLayout>
</template>

<script setup lang="ts">
import BaseLayout from '~/components/base-layout.vue';
</script>

<style lang="scss" scoped>
.layout--minimal {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  :deep(.layout__container) {
    flex: 1 1 100%;
  }
}
</style>
